module.exports = __webpack_public_path__ + "img/grand.33e73a2c.png";